








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Slider extends Vue {
  @Prop() length!: number;
  @Prop() activeIndex!: number;

  public get sliderItemList() {
    return new Array(this.length)
      .fill(false)
      .map((val, index) => index === this.activeIndex);
  }

  public getDotClass(isActive) {
    return isActive ? 'active' : 'normal';
  }
}
